import React from 'react';

import PageTitleNew from 'components/ui/PageTitleNew';

import Table from './Table';

export default function Index() {
  return (
    <div className="wrapper_assestment invite_wrapper">
      <PageTitleNew title="Webinars" />

      <div className="ibox-content mt20">
        <Table />
      </div>
    </div>
  );
}
